<div class="d-flex flex-row card border-1 h-100 shadow-sm">
  <div class="card-body p-0 ps-4 pe-4 bg-white">
    <div class="row h-100">
      <div class="d-flex flex-row align-items-center col-12 col-md-12 col-sm-4 pe-0">
        <span *ngIf="kpiValue || kpiValue == 0" class="text-black-50 kpi-text font-size-22 fw-bolder kpi-padding"
          [ngClass]="[(colorClass) ? colorClass : '']" title=" {{shortenLargeNumber(kpiValue, 1)}}">
          {{shortenLargeNumber(kpiValue, 1)}}
          <span *ngIf="percent" class="text-black-50 kpi-text font-size-22 fw-bolder"
            [ngClass]="[(colorClass) ? colorClass : '']" title="{{percent.toFixed(2)}}%">
            ({{percent.toFixed(2)}}%)
          </span>
        </span>
        <span *ngIf="!kpiValue && kpiValue != 0" class="text-center ps-2 kpi-padding">
          <div class="spinner-border spinnerCls" role="status">
          </div>
        </span>
        <span class="text-black-50 kpi-text font-size-12 pe-1">{{title}}</span>
      </div>
    </div>
  </div>
</div>
